import { render, staticRenderFns } from "./workingBillManagement.vue?vue&type=template&id=2bd68fcd&scoped=true&"
import script from "./workingBillManagement.vue?vue&type=script&lang=ts&"
export * from "./workingBillManagement.vue?vue&type=script&lang=ts&"
import style0 from "./workingBillManagement.vue?vue&type=style&index=0&id=2bd68fcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd68fcd",
  null
  
)

export default component.exports